import Loading from "./loading";

const Container = ({
  children,
  loading,
}: {
  children: React.ReactNode;
  loading: boolean;
}) => {
  return (
    <div className="w-[70%] flex flex-col justify-end pb-6 z-10">
      {loading ? <Loading /> : children}
    </div>
  );
};

export default Container;
